import { makeQuery } from '@core/queries';
import { IPlatformsStatusDto } from '@core/models';

type Output = { getPlatformsStatusAcrossTheApp: IPlatformsStatusDto };

export const getPlatformStatusAcrossTheApp = makeQuery<Output>(`
query GetPlatformsStatusAcrossTheApp {
  ayn {
    getPlatformsStatusAcrossTheApp {
      facebook
      google
      linkedin
      bing
      tiktok
      adcreative
    }
  }
}
`);
